module.exports = __webpack_public_path__ + "img/hamburger-icon.8146845f.svg";